import { useRef, useEffect, useState } from 'react';
import { isOnServer } from './isOnServer';

function matchMedia(mediaQuery) {
  return !isOnServer && window ? window.matchMedia(mediaQuery) : null;
}

export function doMediaMatch(mediaQuery) {
  const { matches } = matchMedia(mediaQuery) || {};
  return matches;
}

export const useMediaChangeEvent = (mediaQuery, listener) => {
  const matchedMedia = matchMedia(mediaQuery);
  const { current: selectedMedia } = useRef(matchedMedia);

  useEffect(() => {
    if ('addEventListener' in selectedMedia) {
      selectedMedia.addEventListener('change', listener);
      return () => selectedMedia.removeEventListener('change', listener);
    } else {
      selectedMedia.addListener(listener);
      return () => selectedMedia.removeListener(listener);
    }
  }, [listener, selectedMedia]);

  return Boolean(selectedMedia?.matches);
};

/**
 * Checks if media query matches or not _only_ on component init
 *
 * ie, will not recalculate on window resize (intentionally to ensure the app to not jump from desktop to mobile image sequence sources)
 *
 * @param {string} mediaQuery
 * @returns {boolean} if media query matches
 */
export const useMediaMatch = mediaQuery => {
  const isMatchOnInit = useMediaChangeEvent(mediaQuery, ({ matches }) => {
    setIsMatch(matches);
  });
  const [isMatch, setIsMatch] = useState(isMatchOnInit);

  return isMatch;
};
